import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren, useState } from "react";
import { useHistory } from "react-router-dom";
import { useEnv } from "./context/env.context";

export const Auth0ProviderWithHistory = ({
    children,
}: PropsWithChildren<any>): JSX.Element | null => {
    const history = useHistory();
    const { domain, clientId, applicationId, tenantId } = useEnv();
    const [redirectStatus, setRedirectStatus] = useState(sessionStorage.getItem("redirectOnLogOut"));
    const [redirectUrl, setRedirectUrl] = useState(sessionStorage.getItem("returnToAp1"));

    const onRedirectCallback = (appState: AppState | undefined) => {
        if (redirectStatus === "true" && redirectUrl) {
            history.push(redirectUrl);
        }
        else {
            history.push(appState?.returnTo || window.location.pathname);
        }
    };

    if (!(domain && clientId)) {
        return null;
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
            scope={`openid profile email loginApplicationId-${applicationId} tenantId-${tenantId} signup-false`}
        >
            {children}
        </Auth0Provider>
    );
};